module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/video-poster-3-7a5e75ee23c2663495dad923cb3969f2.jpg";